import { render } from "./OccupationalSafetyExpertsAPage.vue?vue&type=template&id=e23060a4&scoped=true"
import script from "./OccupationalSafetyExpertsAPage.vue?vue&type=script&lang=js"
export * from "./OccupationalSafetyExpertsAPage.vue?vue&type=script&lang=js"

import "./OccupationalSafetyExpertsAPage.vue?vue&type=style&index=0&id=e23060a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23060a4"]])

export default __exports__